<template>
  <div class="research_group_container">
    <div class="hd research-background-color" v-if="billInfo">
      <!--<span class="icon icon-left navshare" @click="$emit('toggleShow')"></span>-->
      <span class="header_title">{{billInfo.year}}年账单</span>
      <svg class="arrow_down" @click="$emit('toggleShow')" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
    </div>
    <BillList :billInfo="billInfo"/>
  </div>
</template>
<script>
// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'
import BillList from './BillList'

export default {
  data () {
    return {
      deliverIsOpen: false,
      consumeIsOpen: false,
      contractInfo: {},
      selected: '累计',
      type: '',
      showBillDetail: false
    }
  },
  components: {
    BillList
  },
  props: [
    'billInfo'
  ],
  computed: {
    deliverContractList () {
      if (this.billInfo && this.billInfo.deliverContractList) return this.billInfo.deliverContractList
      return {}
    },
    consumeContractList () {
      if (this.billInfo && this.billInfo.consumeContractList) return this.billInfo.consumeContractList
      return {}
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    showBillInfo (detail, type) {
      this.contractInfo = detail
      this.type = type
      this.showBillDetail = !this.showBillDetail
      console.log('detail', detail)
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:auto;
  overflow-x:hidden;
  background-color: #efeef3;
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}
.arrow_down {
  position: absolute;
  right: 8vw;
  margin-left: 27vw;
  /* width: 2.67vw;
  height: 1.73vw; */
}


.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

</style>



// WEBPACK FOOTER //
// AnnualBillDetail.vue?11010120